import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Row, Col, Card, CardBody, Button, Modal, Badge } from 'reactstrap';
import Datatables from "../../utils/table/datatable";
import Dropzone from "react-dropzone";
import SignaturePad from 'react-signature-pad-wrapper';
import { get, post, put, del } from 'helpers/api_helper';
import { DOCTOR_URL, DOCTOR_TIMING_URL, CHAIR_URL } from 'helpers/url_helper';
import { ManageDoctorColumns } from './tableColumns';
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { showSuccessAlert, showErroeAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import cookieHelper from 'helpers/getCookieData';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    RiHospitalLine,
    RiTimeLine,
    RiUserHeartLine,
    RiCheckLine,
    RiCloseLine,
    RiDeleteBin6Line,
    RiAddCircleLine,
    RiAlertLine,
    RiBookmarkLine,
    RiStethoscopeLine
} from 'react-icons/ri';

const timeOptions = [
    { label: "07:00 AM", value: "07:00:00" },
    { label: "07:30 AM", value: "07:30:00" },
    { label: "08:00 AM", value: "08:00:00" },
    { label: "08:30 AM", value: "08:30:00" },
    { label: "09:00 AM", value: "09:00:00" },
    { label: "09:30 AM", value: "09:30:00" },
    { label: "10:00 AM", value: "10:00:00" },
    { label: "10:30 AM", value: "10:30:00" },
    { label: "11:00 AM", value: "11:00:00" },
    { label: "11:30 AM", value: "11:30:00" },
    { label: "12:00 PM", value: "12:00:00" },
    { label: "12:30 PM", value: "12:30:00" },
    { label: "01:00 PM", value: "13:00:00" },
    { label: "01:30 PM", value: "13:30:00" },
    { label: "02:00 PM", value: "14:00:00" },
    { label: "02:30 PM", value: "14:30:00" },
    { label: "03:00 PM", value: "15:00:00" },
    { label: "03:30 PM", value: "15:30:00" },
    { label: "04:00 PM", value: "16:00:00" },
    { label: "04:30 PM", value: "16:30:00" },
    { label: "05:00 PM", value: "17:00:00" },
    { label: "05:30 PM", value: "17:30:00" },
    { label: "06:00 PM", value: "18:00:00" },
    { label: "06:30 PM", value: "18:30:00" },
    { label: "07:00 PM", value: "19:00:00" },
    { label: "07:30 PM", value: "19:30:00" },
    { label: "08:00 PM", value: "20:00:00" },
    { label: "08:30 PM", value: "20:30:00" },
    { label: "09:00 PM", value: "21:00:00" },
    { label: "09:30 PM", value: "21:30:00" },
    { label: "10:00 PM", value: "22:00:00" }
];

const toSec = (t) => {
    if (!t) return 0;
    const [h, m, s] = t.split(':').map(Number);
    return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
};

const ManageDoctor = () => {
    const { t } = useTranslation();
    const clinic = cookieHelper.getCookie('_c') ? JSON.parse(atob(cookieHelper.getCookie('_c'))) : null;

    const [isForm, setIsForm] = useState(false);
    const [isAssignModal, setIsAssignModal] = useState(false);
    const [selectedDoctorForAssign, setSelectedDoctorForAssign] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedColor, setSelectedColor] = useState('#F8CA15');
    const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);
    const [signature, setSignature] = useState(null);
    const [formData, setFormData] = useState({});
    const [editingId, setEditingId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });
    const [rows1, setrows1] = useState([{ id: 1 }]);

    // Chair Allocation States
    const [chairsList, setChairsList] = useState([]);
    const [allAllocations, setAllAllocations] = useState([]);
    const [selectedChairId, setSelectedChairId] = useState('');
    const [allocStartTime, setAllocStartTime] = useState('08:00:00');
    const [allocEndTime, setAllocEndTime] = useState('11:00:00');
    const [allocating, setAllocating] = useState(false);

    const signaturePad = useRef(null);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setSignature(null);
        setSelectedColor('#F8CA15');
        signaturePad.current?.clear?.();
    };

    const handleClearSignature = () => {
        signaturePad.current?.clear?.();
        setSignature(null);
        setIsSignatureEmpty(true);
    };

    const handleSignatureChange = () => {
        const isEmpty = signaturePad.current ? signaturePad.current.isEmpty() : true;
        setIsSignatureEmpty(isEmpty);
    };

    const handleAcceptedFiles = (files) => {
        if (files && files.length > 0) {
            const file = files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setSignature(reader.result);
                setIsSignatureEmpty(false);
            };
            reader.readAsDataURL(file);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        const { success, body } = await get(`${DOCTOR_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setRows(body);
            setLoading(false);
        }
    };

    const fetchChairsAndAllocations = async () => {
        const [chairsRes, allocRes] = await Promise.all([
            get(`${CHAIR_URL}?limit=all`),
            get(`${DOCTOR_TIMING_URL}?limit=all`)
        ]);

        if (chairsRes?.success || chairsRes?.body) {
            const chairs = chairsRes?.body?.items || chairsRes?.body || [];
            setChairsList(chairs);
            if (chairs.length > 0 && !selectedChairId) {
                setSelectedChairId(String(chairs[0].id));
                if (chairs[0].start_time && chairs[0].end_time) {
                    setAllocStartTime(chairs[0].start_time);
                    setAllocEndTime(chairs[0].end_time);
                }
            }
        }
        if (allocRes?.success || allocRes?.body || allocRes?.items) {
            const list = allocRes?.body?.items || allocRes?.body || allocRes?.items || [];
            setAllAllocations(list);
        }
    };

    useEffect(() => {
        fetchData();
        fetchChairsAndAllocations();
    }, [pagination]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const url = editMode ? `${DOCTOR_URL}/${editingId}` : DOCTOR_URL;
        const method = editMode ? put : post;

        let sig = signature;
        if (!sig && signaturePad.current && !signaturePad.current.isEmpty()) {
            sig = signaturePad.current.getTrimmedCanvas().toDataURL('image/png');
        }

        const data = { ...formData, color_code: selectedColor, signature: sig, clinic_id: clinic?.id };

        const { success, body } = await method(url, data);

        if (success) {
            showSuccessAlert(editMode ? 'Doctor updated successfully!' : 'Doctor created successfully!');

            if (!editMode) {
                const doctorId = body?.id;
                const timings = rows1.map(row => ({
                    doctor_id: doctorId,
                    start_time: row.startTime,
                    end_time: row.endTime,
                    exe_time: row.exe_time,
                    clinic_id: clinic?.id
                }));
                await post(DOCTOR_TIMING_URL, timings);
            }

            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            setSignature(null);
            signaturePad.current?.clear?.();
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please fill all required fields correctly.");
    };

    const handleColorChange = (e) => {
        const color = e.target.value;
        setSelectedColor(color);
        setFormData(prev => ({
            ...prev,
            color_code: color
        }));
    };

    function handleAddRowNested() {
        const modifiedRows = [...rows1];
        modifiedRows.push({ id: modifiedRows.length + 1 });
        setrows1(modifiedRows);
    }

    function handleRemoveRow(id) {
        if (id !== 1) {
            let modifiedRows = [...rows1];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setrows1(modifiedRows);
        }
    }

    const handleTimingChange = (id, field, value) => {
        setrows1(prevRows =>
            prevRows.map(row =>
                row.id === id
                    ? { ...row, [field]: value }
                    : row
            )
        );
    };

    const handleEdit = (row) => {
        setFormData(row);
        setSelectedColor(row.color_code || '#F8CA15');
        setSignature(row.signature || null);
        setEditingId(row.id);
        setEditMode(true);
        setIsForm(true);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} Doctor`, `Do you really want to ${action} this Doctor?`,
            `Yes, ${action} it!`, `${action}d!`, `Doctor has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${DOCTOR_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    // Open Chair Allocation Modal
    const handleOpenAssignModal = (doctor) => {
        setSelectedDoctorForAssign(doctor);
        fetchChairsAndAllocations();
        setIsAssignModal(true);
    };

    const handleCloseAssignModal = () => {
        setIsAssignModal(false);
        setSelectedDoctorForAssign(null);
    };

    // Currently selected chair object
    const currentSelectedChair = useMemo(() => {
        return chairsList.find(c => String(c.id) === String(selectedChairId)) || chairsList[0] || null;
    }, [chairsList, selectedChairId]);

    // Update time defaults when chair selection changes
    const handleChairSelectChange = (chairId) => {
        setSelectedChairId(chairId);
        const chair = chairsList.find(c => String(c.id) === String(chairId));
        if (chair?.start_time && chair?.end_time) {
            setAllocStartTime(chair.start_time);
            setAllocEndTime(chair.end_time);
        }
    };

    // Filter allocations for the selected chair
    const selectedChairAllocations = useMemo(() => {
        if (!selectedChairId) return [];
        return allAllocations.filter(a => String(a.chair_code) === String(selectedChairId) && Number(a.status) === 0);
    }, [allAllocations, selectedChairId]);

    // Filter allocations belonging to the currently selected doctor
    const currentDoctorAllocations = useMemo(() => {
        if (!selectedDoctorForAssign) return [];
        return allAllocations.filter(a => {
            if (Number(a.status) !== 0) return false;
            const matchesCode = a.doctor_code && a.doctor_code === selectedDoctorForAssign.code;
            const matchesDocCode = a.doctor?.code && a.doctor.code === selectedDoctorForAssign.code;
            const matchesDocId = a.doctor?.id && String(a.doctor.id) === String(selectedDoctorForAssign.id);
            return matchesCode || matchesDocCode || matchesDocId;
        });
    }, [allAllocations, selectedDoctorForAssign]);

    // Conflict detection
    const allocationConflict = useMemo(() => {
        const startSec = toSec(allocStartTime);
        const endSec = toSec(allocEndTime);

        if (startSec >= endSec) {
            return { hasConflict: true, message: "End Time must be greater than Start Time." };
        }

        // Check if overlaps with any other doctor's allocation on the same chair
        const conflictItem = selectedChairAllocations.find(a => {
            const isSameDoctor = (
                (a.doctor_code && a.doctor_code === selectedDoctorForAssign?.code) ||
                (a.doctor?.code && a.doctor.code === selectedDoctorForAssign?.code) ||
                (a.doctor?.id && String(a.doctor.id) === String(selectedDoctorForAssign?.id))
            );
            if (isSameDoctor) return false; // same doctor can adjust

            const aStart = toSec(a.start_time);
            const aEnd = toSec(a.end_time);

            return (startSec < aEnd && endSec > aStart);
        });

        if (conflictItem) {
            const docName = conflictItem.doctor?.name || conflictItem.doctor_code || "Another Doctor";
            return {
                hasConflict: true,
                message: `Conflict Detected: ${docName} is already assigned to this chair from ${conflictItem.start_time?.substring(0, 5)} to ${conflictItem.end_time?.substring(0, 5)}!`
            };
        }

        return { hasConflict: false, message: null };
    }, [allocStartTime, allocEndTime, selectedChairAllocations, selectedDoctorForAssign]);

    // Handle saving chair allocation to doctor
    const handleSaveChairAllocation = async () => {
        if (allocationConflict.hasConflict) {
            showErroeAlert(allocationConflict.message || "Cannot allocate overlapping time slot!");
            return;
        }

        setAllocating(true);
        const payload = {
            doctor_code: selectedDoctorForAssign?.code,
            chair_code: currentSelectedChair?.id,
            start_time: allocStartTime,
            end_time: allocEndTime,
            exe_time: currentSelectedChair?.intervel || 30,
            clinic_id: clinic?.id,
            status: 0
        };

        const res = await post(DOCTOR_TIMING_URL, payload);
        setAllocating(false);

        if (res?.success || res?.id || res?.body) {
            showSuccessAlert(`Chair allocated to ${selectedDoctorForAssign?.name} successfully!`);
            await Promise.all([fetchData(), fetchChairsAndAllocations()]);
        } else {
            showErroeAlert("Unable to save chair allocation. Please try again.");
        }
    };

    // Handle deleting an allocation
    const handleDeleteAllocation = async (allocationId) => {
        const { isConfirmed } = await showConfirmAlert("Remove Chair Allocation", "Do you want to de-allocate this time slot from the doctor?", "Yes, Remove", "Removed!", "Allocation removed successfully.");
        if (isConfirmed) {
            const res = await del(`${DOCTOR_TIMING_URL}/${allocationId}?sts=1`);
            if (res?.success || res) {
                showSuccessAlert("Allocation removed successfully.");
                await Promise.all([fetchData(), fetchChairsAndAllocations()]);
            }
        }
    };

    // Compute enhanced doctor rows with pre-attached chair allocations
    const enhancedRows = useMemo(() => {
        const items = rows?.items || (Array.isArray(rows) ? rows : []);
        if (!Array.isArray(items)) return [];
        return items.map(doc => {
            const docAllocations = (allAllocations || []).filter(a => {
                if (Number(a.status) !== 0) return false;
                const aCode = String(a.doctor_code || a.doctor?.code || '').trim().toLowerCase();
                const rCode = String(doc.code || '').trim().toLowerCase();
                if (aCode && rCode && aCode === rCode) return true;

                const aId = String(a.doctor_id || a.doctor?.id || '');
                const rId = String(doc.id || '');
                if (aId && rId && aId === rId) return true;

                const aName = String(a.doctor?.name || '').trim().toLowerCase();
                const rName = String(doc.name || '').trim().toLowerCase();
                if (aName && rName && aName === rName) return true;

                if (aCode && rId && aCode === rId) return true;
                if (rCode && aId && rCode === aId) return true;

                return false;
            });
            return {
                ...doc,
                allocated_chairs_list: docAllocations,
            };
        });
    }, [rows, allAllocations]);

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageDoctorColumns({
                            edit: handleEdit,
                            delete: handleDelete,
                            assignChair: handleOpenAssignModal,
                            allocations: allAllocations
                        }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={enhancedRows}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title={t("All Doctors & Specialists")}
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            {/* Doctor Profile Add / Edit Modal */}
            <Modal isOpen={isForm} toggle={handleToggle} size="lg" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <div className="d-flex align-items-center gap-2">
                            <div className="p-2 rounded bg-primary-subtle text-primary font-size-18 d-flex align-items-center justify-content-center">
                                <RiStethoscopeLine />
                            </div>
                            <div>
                                <h5 className="modal-title font-weight-bold mb-0">
                                    {editMode ? t("Update Doctor Profile") : t("Add New Doctor / Specialist")}
                                </h5>
                                <span className="text-muted font-size-12">{t("Enter doctor profile details, contact info, calendar color, and signature")}</span>
                            </div>
                        </div>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-3 p-md-4">
                        <Row className="g-3">
                            <Col md={6}>
                                <div>
                                    <AvField
                                        name="name"
                                        label={t("Full Name *")}
                                        type="text"
                                        placeholder={t("e.g. Dr. Jane Doe")}
                                        value={formData.name || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage={t("Please enter Full Name")}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div>
                                    <AvField
                                        name="code"
                                        label={t("Doctor Code *")}
                                        type="text"
                                        placeholder={t("e.g. DOC-001")}
                                        value={formData.code || ''}
                                        onChange={handleChange}
                                        disabled={editMode}
                                        required
                                        errorMessage={t("Please enter Code")}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div>
                                    <AvField
                                        name="registration_no"
                                        label={t("Licence / DCI Reg *")}
                                        type="text"
                                        placeholder={t("e.g. DCI-99881")}
                                        value={formData.registration_no || ''}
                                        disabled={editMode}
                                        onChange={handleChange}
                                        required
                                        errorMessage={t("Please enter Registration Number")}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="g-3 mt-1">
                            <Col md={4}>
                                <div>
                                    <AvField
                                        name="mobile"
                                        label={t("Mobile Number *")}
                                        type="text"
                                        placeholder={t("e.g. +91 9876543210")}
                                        value={formData.mobile || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage={t("Please enter Mobile Number")}
                                    />
                                </div>
                            </Col>
                            <Col md={5}>
                                <div>
                                    <AvField
                                        name="email"
                                        label={t("Email Address *")}
                                        type="email"
                                        placeholder={t("e.g. doctor@clinic.com")}
                                        value={formData.email || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage={t("Please enter Email Address")}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div>
                                    <label className="form-label font-weight-semibold">{t("Color Code")}</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            type="color"
                                            className="form-control form-control-color p-1"
                                            value={selectedColor}
                                            onChange={handleColorChange}
                                            style={{ width: '42px', height: '38px', borderRadius: '6px' }}
                                        />
                                        <span className="font-monospace text-slate-700 font-size-12 font-weight-bold">{selectedColor}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Digital Signature Section */}
                        <div className="mt-3 p-3 rounded" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <label className="form-label font-weight-semibold mb-0 font-size-13 text-slate-800">
                                    {t("Doctor Digital Signature")}
                                </label>
                                <div className="d-flex align-items-center gap-2">
                                    {signature && (
                                        <span className="badge bg-success-subtle text-success font-size-11">
                                            {t("Signature Captured")}
                                        </span>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary py-0 px-2 font-size-11"
                                        onClick={handleClearSignature}
                                    >
                                        {t("Clear")}
                                    </button>
                                </div>
                            </div>

                            <Row className="g-2">
                                <Col md={6}>
                                    <div className="p-2 bg-white rounded border" style={{ height: '90px' }}>
                                        <Dropzone onDrop={handleAcceptedFiles} accept="image/*">
                                            {({ getRootProps, getInputProps }) => (
                                                <div
                                                    {...getRootProps()}
                                                    className="d-flex flex-column align-items-center justify-content-center h-100 text-center"
                                                    style={{ border: '1.5px dashed #cbd5e1', borderRadius: '6px', cursor: 'pointer', padding: '6px' }}
                                                >
                                                    <input {...getInputProps()} />
                                                    <i className="bx bxs-cloud-upload text-primary font-size-20" />
                                                    <span className="text-muted font-size-11 mt-1">{t("Upload Signature File")}</span>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div
                                        className="position-relative rounded bg-white border d-flex align-items-center justify-content-center overflow-hidden"
                                        style={{ height: '90px', borderStyle: 'dashed' }}
                                        onClick={handleSignatureChange}
                                    >
                                        {isSignatureEmpty && !signature && (
                                            <div className="position-absolute text-muted opacity-50 font-size-11 text-center" style={{ pointerEvents: 'none' }}>
                                                {t("Draw signature with mouse / touch")}
                                            </div>
                                        )}
                                        {signature ? (
                                            <img
                                                src={signature}
                                                alt="Doctor Signature"
                                                style={{ maxHeight: '75px', maxWidth: '90%', objectFit: 'contain' }}
                                            />
                                        ) : (
                                            <SignaturePad ref={signaturePad} height={85} onEnd={handleSignatureChange} />
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" onClick={handleToggle}>
                            {t("Cancel")}
                        </button>
                        <button type="submit" className="btn btn-primary font-weight-semibold px-4" disabled={loading}>
                            {loading ? t("Saving...") : (editMode ? t("Update Doctor Profile") : t("Save Doctor Profile"))}
                        </button>
                    </div>
                </AvForm>
            </Modal>

            {/* Assign Operatory Chair & Time Allocation Modal */}
            <Modal isOpen={isAssignModal} toggle={handleCloseAssignModal} size="xl" centered>
                <div className="modal-header border-bottom py-3 px-4 bg-light">
                    <div className="d-flex align-items-center gap-2.5">
                        <div
                            className="rounded-3 d-flex align-items-center justify-content-center text-dark font-size-20 shadow-2xs"
                            style={{ width: '42px', height: '42px', backgroundColor: '#F8CA15' }}
                        >
                            <RiHospitalLine />
                        </div>
                        <div>
                            <h5 className="modal-title font-weight-bold text-slate-900 mb-0 font-size-16">
                                {t("Assign Operatory Chair & Time Window")}
                            </h5>
                            <span className="text-muted font-size-12">
                                {t("Allocate clinic operatory chairs and time slots to this doctor")}
                            </span>
                        </div>
                    </div>
                    <button type="button" className="btn-close" onClick={handleCloseAssignModal} aria-label="Close" />
                </div>

                <div className="modal-body p-4">
                    {/* Doctor Info Card */}
                    <div
                        className="p-3 mb-4 rounded-3 d-flex align-items-center justify-content-between flex-wrap gap-3 shadow-2xs"
                        style={{ background: '#f8fafc', border: '1.5px solid #e2e8f0' }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold font-size-18 shadow-sm flex-shrink-0"
                                style={{ width: 46, height: 46, backgroundColor: selectedDoctorForAssign?.color_code || '#F8CA15' }}
                            >
                                {selectedDoctorForAssign?.name ? selectedDoctorForAssign.name.charAt(0).toUpperCase() : 'D'}
                            </div>
                            <div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                    <h5 className="font-weight-bold text-slate-900 mb-0 font-size-15">{selectedDoctorForAssign?.name}</h5>
                                    <span className="badge bg-light text-primary border font-monospace font-size-11">
                                        {selectedDoctorForAssign?.code}
                                    </span>
                                </div>
                                <div className="text-muted font-size-12 mt-0.5 d-flex align-items-center gap-2 flex-wrap">
                                    {selectedDoctorForAssign?.mobile && <span>📱 {selectedDoctorForAssign.mobile}</span>}
                                    {selectedDoctorForAssign?.registration_no && (
                                        <span>• {t("Reg")}: <strong>{selectedDoctorForAssign.registration_no}</strong></span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-1.5 font-size-12 font-weight-semibold">
                                <RiStethoscopeLine className="me-1" /> {selectedDoctorForAssign?.specialization || t("General Dental Specialist")}
                            </span>
                        </div>
                    </div>

                    {/* Chair & Shift Selection Section */}
                    <Row className="g-3 mb-4">
                        <Col lg={5}>
                            <div className="h-100 p-3 rounded-3 bg-white border d-flex flex-column justify-content-between">
                                <div>
                                    <label className="form-label font-size-12 font-weight-bold text-slate-700 mb-1.5">
                                        {t("Select Operatory Chair / Cabin *")}
                                    </label>
                                    <select
                                        className="form-select font-weight-semibold font-size-13 py-2"
                                        value={selectedChairId}
                                        onChange={(e) => handleChairSelectChange(e.target.value)}
                                    >
                                        {chairsList.map(c => (
                                            <option key={c.id} value={c.id}>
                                                {c.title} ({t("Cabin")} {c.cabin_no}) [{c.start_time?.substring(0, 5)} - {c.end_time?.substring(0, 5)}]
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {currentSelectedChair && (
                                    <div className="mt-2.5 pt-2 border-top d-flex align-items-center justify-content-between text-muted font-size-11">
                                        <span>
                                            🕒 {t("Hours")}: <strong>{currentSelectedChair.start_time?.substring(0, 5)} - {currentSelectedChair.end_time?.substring(0, 5)}</strong>
                                        </span>
                                        <span>
                                            ⏱️ {t("Interval")}: <strong>{currentSelectedChair.intervel || 30} mins</strong>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Col>

                        <Col lg={7}>
                            <div className="p-3 rounded-3 bg-light border h-100 d-flex flex-column justify-content-between">
                                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                                    <span className="font-weight-bold text-slate-800 font-size-12 d-flex align-items-center gap-1">
                                        <RiTimeLine className="text-primary" /> {t("Chair Day Timeline & Occupied Allocations")}
                                    </span>
                                    <span className="badge bg-white text-muted border font-size-11">
                                        {selectedChairAllocations.length} {t("Active Allocations")}
                                    </span>
                                </div>

                                {/* Visual Timeline Schedule Bar */}
                                <div className="p-2.5 bg-white rounded-2 border">
                                    {selectedChairAllocations.length === 0 ? (
                                        <div className="text-success font-size-12 font-weight-semibold d-flex align-items-center gap-1 py-1">
                                            <span>✅</span>
                                            <span>{t("All operating hours are currently unallocated & available!")} ({currentSelectedChair?.start_time?.substring(0, 5)} - {currentSelectedChair?.end_time?.substring(0, 5)})</span>
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-wrap gap-1.5">
                                            {selectedChairAllocations.map((alloc, aIdx) => {
                                                const isMe = alloc.doctor_code === selectedDoctorForAssign?.code;
                                                return (
                                                    <div
                                                        key={`alloc-block-${alloc.id || aIdx}`}
                                                        className="d-inline-flex align-items-center gap-1.5 px-2 py-1 rounded font-size-11 font-weight-semibold"
                                                        style={{
                                                            backgroundColor: isMe ? '#dcfce7' : '#fee2e2',
                                                            color: isMe ? '#166534' : '#991b1b',
                                                            border: `1px solid ${isMe ? '#86efac' : '#fca5a5'}`
                                                        }}
                                                    >
                                                        <span>{alloc.doctor?.name || alloc.doctor_code}:</span>
                                                        <span className="font-monospace">({alloc.start_time?.substring(0, 5)} - {alloc.end_time?.substring(0, 5)})</span>
                                                        {isMe && <span className="badge bg-success font-size-9 ms-0.5">{t("This Doctor")}</span>}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Time Window Picker & Presets */}
                    <div className="p-3 rounded-3 border mb-4 shadow-2xs" style={{ background: '#fcfcfd' }}>
                        <div className="d-flex align-items-center justify-content-between mb-2.5">
                            <span className="font-weight-bold text-slate-800 font-size-13 d-flex align-items-center gap-1.5">
                                <RiBookmarkLine className="text-warning" /> {t("Set Allocated Time Window")}
                            </span>
                            <span className="text-muted font-size-11">{t("Select shift timing or pick a quick preset")}</span>
                        </div>

                        <Row className="g-3 align-items-end">
                            <Col md={3}>
                                <label className="form-label font-size-11 font-weight-bold text-slate-600 mb-1">{t("Start Time *")}</label>
                                <select
                                    className="form-select font-size-13 py-1.5"
                                    value={allocStartTime}
                                    onChange={(e) => setAllocStartTime(e.target.value)}
                                >
                                    {timeOptions.map(tOption => (
                                        <option key={`st-${tOption.value}`} value={tOption.value}>{tOption.label}</option>
                                    ))}
                                </select>
                            </Col>

                            <Col md={3}>
                                <label className="form-label font-size-11 font-weight-bold text-slate-600 mb-1">{t("End Time *")}</label>
                                <select
                                    className="form-select font-size-13 py-1.5"
                                    value={allocEndTime}
                                    onChange={(e) => setAllocEndTime(e.target.value)}
                                >
                                    {timeOptions.map(tOption => (
                                        <option key={`et-${tOption.value}`} value={tOption.value}>{tOption.label}</option>
                                    ))}
                                </select>
                            </Col>

                            <Col md={4}>
                                <label className="form-label font-size-11 font-weight-bold text-slate-600 mb-1">{t("Quick Slot Presets")}</label>
                                <div className="d-flex gap-1 flex-wrap">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary font-size-11 py-1 px-2 rounded-2"
                                        onClick={() => {
                                            if (currentSelectedChair?.start_time && currentSelectedChair?.end_time) {
                                                setAllocStartTime(currentSelectedChair.start_time);
                                                setAllocEndTime(currentSelectedChair.end_time);
                                            }
                                        }}
                                    >
                                        {t("Full Hours")}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-warning font-size-11 py-1 px-2 rounded-2 text-dark"
                                        onClick={() => { setAllocStartTime('08:00:00'); setAllocEndTime('11:00:00'); }}
                                    >
                                        {t("Morning (08-11)")}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-warning font-size-11 py-1 px-2 rounded-2 text-dark"
                                        onClick={() => { setAllocStartTime('11:00:00'); setAllocEndTime('13:00:00'); }}
                                    >
                                        {t("Midday (11-01)")}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-warning font-size-11 py-1 px-2 rounded-2 text-dark"
                                        onClick={() => { setAllocStartTime('13:00:00'); setAllocEndTime('21:00:00'); }}
                                    >
                                        {t("Evening (01-09)")}
                                    </button>
                                </div>
                            </Col>

                            <Col md={2}>
                                <button
                                    type="button"
                                    className="btn btn-warning font-weight-bold w-100 py-2 d-inline-flex align-items-center justify-content-center gap-1 font-size-13 shadow-sm"
                                    disabled={allocationConflict.hasConflict || allocating}
                                    onClick={handleSaveChairAllocation}
                                    style={{ backgroundColor: '#F8CA15', borderColor: '#EAB308', color: '#0f172a' }}
                                >
                                    <RiCheckLine className="font-size-16" />
                                    <span>{allocating ? t("Saving...") : t("Assign Slot")}</span>
                                </button>
                            </Col>
                        </Row>

                        {/* Conflict Alert */}
                        {allocationConflict.hasConflict && (
                            <div className="mt-2.5 p-2 rounded-2 d-flex align-items-center gap-2" style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', fontSize: '0.82rem' }}>
                                <RiAlertLine className="font-size-16 flex-shrink-0" />
                                <span>{allocationConflict.message}</span>
                            </div>
                        )}
                    </div>

                    {/* Active Allocations for this Doctor */}
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-2.5">
                            <span className="font-weight-bold text-slate-800 font-size-13">
                                {t("Active Chair Allocations for")} <span className="text-dark font-weight-bolder">{selectedDoctorForAssign?.name}</span>
                            </span>
                            <Badge color="warning" className="text-dark font-size-11 px-2 py-1">
                                {currentDoctorAllocations.length} {t("Active Slots")}
                            </Badge>
                        </div>

                        {currentDoctorAllocations.length === 0 ? (
                            <div className="text-center py-4 bg-light rounded-3 border text-muted font-size-13">
                                <RiHospitalLine className="font-size-24 d-block mb-1 text-muted opacity-50 mx-auto" />
                                {t("No operatory chairs currently allocated to this doctor. Use the form above to assign chairs.")}
                            </div>
                        ) : (
                            <div className="table-responsive rounded-3 border overflow-hidden">
                                <table className="table table-hover mb-0 font-size-13 align-middle">
                                    <thead style={{ backgroundColor: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}>
                                        <tr>
                                            <th style={{ width: '45px', textAlign: 'center' }} className="text-muted font-size-11 font-weight-bold">#</th>
                                            <th className="text-slate-700 font-size-11 font-weight-bold">{t("OPERATORY CHAIR")}</th>
                                            <th className="text-slate-700 font-size-11 font-weight-bold">{t("CABIN NO")}</th>
                                            <th className="text-slate-700 font-size-11 font-weight-bold">{t("ALLOCATED TIME WINDOW")}</th>
                                            <th className="text-slate-700 font-size-11 font-weight-bold">{t("DURATION")}</th>
                                            <th style={{ width: '80px', textAlign: 'center' }} className="text-slate-700 font-size-11 font-weight-bold">{t("ACTION")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentDoctorAllocations.map((alloc, idx) => {
                                            const chairObj = chairsList.find(c => String(c.id) === String(alloc.chair_code)) || alloc.chair;
                                            const startFormatted = moment(alloc.start_time, 'HH:mm:ss').format('hh:mm A');
                                            const endFormatted = moment(alloc.end_time, 'HH:mm:ss').format('hh:mm A');
                                            const durationHours = ((toSec(alloc.end_time) - toSec(alloc.start_time)) / 3600).toFixed(1);

                                            return (
                                                <tr key={`doc-alloc-${alloc.id || idx}`}>
                                                    <td className="text-center text-muted font-weight-bold font-size-12">{idx + 1}</td>
                                                    <td>
                                                        <strong className="text-slate-900 font-size-13">{chairObj?.title || `Chair #${alloc.chair_code}`}</strong>
                                                    </td>
                                                    <td>
                                                        <span className="badge bg-light text-slate-700 border font-size-11">
                                                            {t("Cabin")} {chairObj?.cabin_no || '1'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="badge bg-success-subtle text-success border border-success-subtle px-2.5 py-1 font-size-12 font-weight-semibold">
                                                            <RiTimeLine className="me-1" /> {startFormatted} – {endFormatted}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="badge bg-light text-slate-800 border font-size-11">
                                                            {durationHours} {t("Hours")}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="table-action-btn icon-only btn-delete"
                                                            title={t("Remove Allocation")}
                                                            onClick={() => handleDeleteAllocation(alloc.id)}
                                                        >
                                                            <RiDeleteBin6Line />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-footer bg-light border-top py-2 px-4 d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-secondary font-weight-semibold d-inline-flex align-items-center gap-1.5 px-3 py-1.5 font-size-13"
                        onClick={handleCloseAssignModal}
                    >
                        <RiCheckLine />
                        <span>{t("Done & Close")}</span>
                    </button>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default ManageDoctor;
